<template>
  <div class="wt-failed-asset-compact">
    <div class="-actions -always-on">
      <wt-asset-remove @remove="unselectAsset" />
    </div>

    <div class="wt-asset-container">
      <div class="-stage-area">
        <div class="failed-message">Failed to Upload</div>
        <a href="#" class="wt2-link" @click="contactSupport">{{
          'generic.CONTACT_SUPPORT' | culture
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';

export default {
  mixins: [AssetMixins],

  props: {
    asset: { type: Object, required: true },
    csmChatMessage: {
      type: String,
      default:
        'Hi, \n' +
        'Something went wrong during uploading. \n' +
        'can you please check? \n' +
        'Thanks',
    },
  },

  methods: {
    contactSupport() {
      app.intercomController.showNewMessage(this.csmChatMessage).catch(() => {
        // fallback - if there no intercom, go to website support
        app.openSupportTab();
      });
    },

    unselectAsset() {
      this.$emit('remove-asset', this.asset);
    },
  },
};
</script>
